__turbopack_context__.v({
  "h2": "StyleConstants-module__bpPZwa__h2",
  "h2Custom": "StyleConstants-module__bpPZwa__h2Custom",
  "h2Md": "StyleConstants-module__bpPZwa__h2Md",
  "h2Small": "StyleConstants-module__bpPZwa__h2Small",
  "leftSideTextWrapper": "StyleConstants-module__bpPZwa__leftSideTextWrapper",
  "p": "StyleConstants-module__bpPZwa__p",
  "pLarge": "StyleConstants-module__bpPZwa__pLarge",
  "pSmall": "StyleConstants-module__bpPZwa__pSmall",
});
